import createClient from "openapi-fetch";
import type { Middleware } from "openapi-fetch";
import type { paths } from "./schema.js";

/**
 * @backcoach/api-client
 *
 * The typed client. `schema.d.ts` is generated from openapi.json and never
 * hand-edited; this file is the only hand-written part, and it only wires a
 * base URL and a token onto openapi-fetch.
 */
export type { components, paths } from "./schema.js";

export type TokenSource = () => string | null | Promise<string | null>;

export interface ClientOptions {
  baseUrl: string;
  /** Participant token for the extension; the console relies on its cookie. */
  token?: TokenSource;
  fetch?: typeof globalThis.fetch;
  credentials?: RequestCredentials;
}

export type BackCoachClient = ReturnType<typeof createClient<paths>>;

export function createBackCoachClient(options: ClientOptions): BackCoachClient {
  const client = createClient<paths>({
    baseUrl: options.baseUrl,
    ...(options.fetch ? { fetch: options.fetch } : {}),
    ...(options.credentials ? { credentials: options.credentials } : {}),
  });
  if (options.token) {
    const token = options.token;
    const auth: Middleware = {
      async onRequest({ request }) {
        const t = await token();
        if (t && !request.headers.has("Authorization")) {
          request.headers.set("Authorization", `Bearer ${t}`);
        }
        return request;
      },
    };
    client.use(auth);
  }
  return client;
}
